
import { Base } from '../base-component';

import './our-campaigns-grid.component.scss';

export class OurCampaignsGrid extends Base {

	constructor(element: Element) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/our-campaigns-grid/our-campaigns-grid.component.ts